import "./Footer.css"

function Footer() {
	return (
		<footer className="footer">
			<p>2025 Quindío - Colombia</p>
		</footer>
	)
}

export { Footer }
